import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-foreground-300 mb-6">
          <span className="text-xs font-medium text-foreground-600 uppercase tracking-wider">Cos&apos;&egrave; Itaobuy Spreadsheet</span>
        </div>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-snug mb-6">
          Lo strumento che trasforma
          <br />
          la <span className="text-accent-500">ricerca prodotti</span> in
          <br />
          un&apos;esperienza semplice
        </h2>

        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed mb-12">
          Itaobuy Spreadsheet &egrave; uno strumento organizzato che permette agli utenti italiani di trovare facilmente prodotti selezionati attraverso liste strutturate e aggiornate. Risparmia tempo, trova prodotti migliori, e naviga tra categorie con un&apos;esperienza utente ottimizzata.
        </p>

        <div className="flex flex-col lg:flex-row items-center gap-8 mb-12">
          <div className="lg:w-1/2 w-full max-w-sm">
            <div className="rounded-2xl overflow-hidden" style={{ aspectRatio: '1/1' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20catalog%20flat%20lay%20with%20fashion%20accessories%20on%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%20from%20left%20side%2C%20Scandinavian%20interior%20aesthetic%2C%20clean%20modern%20composition%2C%20gentle%20warm%20shadows%2C%20editorial%20lifestyle%20photography&width=800&height=800&seq=about-section-image-01&orientation=squarish"
                alt="Itaobuy Spreadsheet catalogo prodotti organizzato"
                title="Itaobuy Spreadsheet organizzazione prodotti"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-1/2 overflow-x-auto w-full">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="py-4 px-4 text-left text-sm font-semibold text-foreground-800">Metodo</th>
                  <th className="py-4 px-4 text-left text-sm font-semibold text-foreground-800">Tempo</th>
                  <th className="py-4 px-4 text-left text-sm font-semibold text-foreground-800">Organizzazione</th>
                  <th className="py-4 px-4 text-left text-sm font-semibold text-foreground-800">Facilit&agrave;</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-background-100">
                  <td className="py-4 px-4 text-sm font-semibold text-accent-600">Itaobuy Spreadsheet</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Molto veloce</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Alta</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Facile</td>
                </tr>
                <tr className="border-b border-background-100">
                  <td className="py-4 px-4 text-sm text-foreground-600">Ricerca manuale</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Lenta</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Bassa</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Media</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 text-sm text-foreground-600">Social media</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Variabile</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Limitata</td>
                  <td className="py-4 px-4 text-sm text-foreground-600">Difficile</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-12">
          {[
            { icon: 'ri-time-line', label: 'Risparmio di tempo', desc: 'Ricerca ultraveloce' },
            { icon: 'ri-layout-grid-line', label: 'Prodotti organizzati', desc: 'Categorie chiare' },
            { icon: 'ri-search-line', label: 'Ricerca semplice', desc: 'Interfaccia intuitiva' },
            { icon: 'ri-star-line', label: 'Esperienza migliore', desc: 'Qualit&agrave; garantita' },
          ].map((item) => (
            <div key={item.label} className="p-5 rounded-xl bg-background-100 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center text-accent-500">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-1">{item.label}</h4>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-8">
          <div className="lg:w-1/2 order-2 lg:order-1">
            <div className="text-left">
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-4">Come Funziona in 4 Semplici Passi</h3>
              <div className="space-y-4">
                {[
                  { step: '01', title: 'Accedi allo Spreadsheet', desc: 'Apri la piattaforma principale senza registrazione' },
                  { step: '02', title: 'Scegli la Categoria', desc: 'Usa il menu a tendina per selezionare tra 14 categorie' },
                  { step: '03', title: 'Esplora i Prodotti', desc: 'Sfoglia liste curate e confronta le opzioni disponibili' },
                  { step: '04', title: 'Procedi all\'Acquisto', desc: 'Clicca sul prodotto e vieni reindirizzato al sito di acquisto' },
                ].map((item) => (
                  <div key={item.step} className="flex items-start gap-4">
                    <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-xs font-bold text-accent-600">{item.step}</span>
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{item.title}</p>
                      <p className="text-xs text-foreground-500">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 w-full max-w-sm order-1 lg:order-2">
            <div className="rounded-2xl overflow-hidden" style={{ aspectRatio: '1/1' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Step%20by%20step%20workflow%20visualization%20with%20organized%20fashion%20items%20arranged%20in%20sequence%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20Scandinavian%20process%20diagram%20aesthetic%2C%20clean%20modern%20composition%2C%20gentle%20warm%20tones&width=800&height=800&seq=about-howto-image-02&orientation=squarish"
                alt="Come funziona Itaobuy Spreadsheet in 4 passi"
                title="Guida passo passo Itaobuy Spreadsheet"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <div className="mt-12">
          <Link
            to="/articolo/guida-completa-itaobuy-spreadsheet"
            className="inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Leggi la Guida Completa
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}